import axios from "axios";
// initial state
const state = {};

// getters
const getters = {};

// actions
const actions = {
  GetFilters({ commit }, list) {
    return new Promise(resolve => {
      axios({
        url: "/stop_text/list?order_by=created_on&order_dir=desc",
        params: {
          page: list.page,
          text: list.search ? '*' + list.search + '*' : '',
          per_page: list.per_page
        },
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  GetFilter({ commit }, id) {
    return new Promise(resolve => {
      axios({
        url: "/stop_text/" + id,
        method: "GET"
      }).then(res => {
        resolve(res.data.payload);
      });
    });
  },
  AddFilter({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/stop_text/create",
        data: filter.filter,
        method: "POST"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },
  EditFilter({ commit }, filter) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/stop_text/" + filter.id,
        data: filter.filter,
        method: "PATCH"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },
  DeleteFilter({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios({
        url: "/stop_text/" + id,
        method: "DELETE"
      }).then(res => {
        resolve(res.data.payload);
      }).catch(err => {
        reject(err);
      });
    });
  },

};
// mutations
const mutations = {

};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations
};
